/**
* @file 系统设置-短信管理-短信模板
* */
<template>
  <div id="smsTemplate">
    <div class="sms-layout">
      <!-- 左侧编辑区 -->
      <div class="sms-editor">
        <el-tabs class="custom-el-tabs" v-model="activeName">
          <el-tab-pane label="司机端" name="driverSms">
            <p class="util-remark" style="margin-bottom: 20px">注意：您可以根据运营场景，自定义短信模版</p>
            <div class="sms-list">
              <div v-for="(item, index) in driverSms" :key="index" class="smsItem"
                :class="{ 'smsItem--active': previewItem === item }"
                @click="setPreview(item)">
                <div class="smsItem__header">
                  <span class="smsItem__label">{{ item.label }}</span>
                  <div class="smsItem__actions">
                    <el-switch v-model="item.isSend" active-text="启用" inactive-text="禁用" style="margin-right:12px"></el-switch>
                    <el-button type="text" size="small" @click.stop="defaultClick(item)">使用默认文案</el-button>
                    <el-button type="text" size="small" style="color:#F56C6C" @click.stop="removeItem('driverSms', index)" v-if="item.isDeletable === 1 || item._custom">删除</el-button>
                  </div>
                </div>
                <el-input
                  type="textarea" :rows="2" maxlength="180"
                  :placeholder="item.defaultContent || item.default"
                  v-model.trim="item.template"
                  :ref="'tpl_' + item.identification"
                  @focus="focusItem = item"
                  @input="item === previewItem && $forceUpdate()"></el-input>
                <div class="param-tags" v-if="itemParams(item).length">
                  <span class="param-tags__title">可用参数：</span>
                  <el-tag
                    v-for="p in itemParams(item)" :key="p"
                    size="mini" type="primary" class="param-tag"
                    @click.stop="insertParam(item, p)">
                    {{ PARAM_LABELS[p] || p }}
                    <span class="param-tag__code">#{{ p }}#</span>
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="sms-footer">
              <el-button size="small" icon="el-icon-plus" @click="addItem('driverSms')">新增模板</el-button>
              <el-button type="primary" @click="saveClick('driverSms')" :loading="loading">保存所有模板</el-button>
            </div>
          </el-tab-pane>

          <el-tab-pane label="小程序" name="passengerSms" v-if="mixinUserInfo.platformType !== 3">
            <p class="util-remark" style="margin-bottom: 20px">注意：您可以根据运营场景，自定义短信模版</p>
            <div class="sms-group-title">定制专线</div>
            <div class="sms-list">
              <div v-for="(item, index) in dingzhiPassenger" :key="'dz'+index" class="smsItem"
                :class="{ 'smsItem--active': previewItem === item }" @click="setPreview(item)">
                <div class="smsItem__header">
                  <span class="smsItem__label">{{ item.label }}</span>
                  <div class="smsItem__actions">
                    <el-switch v-model="item.isSend" active-text="启用" inactive-text="禁用" style="margin-right:12px"></el-switch>
                    <el-button type="text" size="small" @click.stop="defaultClick(item)">使用默认文案</el-button>
                    <el-button type="text" size="small" style="color:#F56C6C" @click.stop="removeItemByRef(item)" v-if="item.isDeletable === 1 || item._custom">删除</el-button>
                  </div>
                </div>
                <el-input
                  type="textarea" :rows="2" maxlength="180"
                  :placeholder="item.defaultContent || item.default"
                  v-model.trim="item.template"
                  :ref="'tpl_' + item.identification"
                  @focus="focusItem = item"
                  @input="item === previewItem && $forceUpdate()"></el-input>
                <div class="param-tags" v-if="itemParams(item).length">
                  <span class="param-tags__title">可用参数：</span>
                  <el-tag
                    v-for="p in itemParams(item)" :key="p"
                    size="mini" type="primary" class="param-tag"
                    @click.stop="insertParam(item, p)">
                    {{ PARAM_LABELS[p] || p }}
                    <span class="param-tag__code">#{{ p }}#</span>
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="sms-group-title" style="margin-top:16px">文旅专线</div>
            <div class="sms-list">
              <div v-for="(item, index) in wenlvPassenger" :key="'wl'+index" class="smsItem"
                :class="{ 'smsItem--active': previewItem === item }" @click="setPreview(item)">
                <div class="smsItem__header">
                  <span class="smsItem__label">{{ item.label }}</span>
                  <div class="smsItem__actions">
                    <el-switch v-model="item.isSend" active-text="启用" inactive-text="禁用" style="margin-right:12px"></el-switch>
                    <el-button type="text" size="small" @click.stop="defaultClick(item)">使用默认文案</el-button>
                    <el-button type="text" size="small" style="color:#F56C6C" @click.stop="removeItemByRef(item)" v-if="item.isDeletable === 1 || item._custom">删除</el-button>
                  </div>
                </div>
                <el-input
                  type="textarea" :rows="2" maxlength="180"
                  :placeholder="item.defaultContent || item.default"
                  v-model.trim="item.template"
                  :ref="'tpl_' + item.identification"
                  @focus="focusItem = item"
                  @input="item === previewItem && $forceUpdate()"></el-input>
                <div class="param-tags" v-if="itemParams(item).length">
                  <span class="param-tags__title">可用参数：</span>
                  <el-tag
                    v-for="p in itemParams(item)" :key="p"
                    size="mini" type="primary" class="param-tag"
                    @click.stop="insertParam(item, p)">
                    {{ PARAM_LABELS[p] || p }}
                    <span class="param-tag__code">#{{ p }}#</span>
                  </el-tag>
                </div>
              </div>
            </div>
            <div class="sms-footer">
              <el-button size="small" icon="el-icon-plus" @click="addItem('passengerSms', 'dingzhi')">新增定制专线模板</el-button>
              <el-button size="small" icon="el-icon-plus" @click="addItem('passengerSms', 'wenlv')">新增文旅专线模板</el-button>
              <el-button type="primary" @click="saveClick('passengerSms')" :loading="loading">保存所有模板</el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <!-- 右侧手机预览区 -->
      <div class="sms-preview">
        <div class="preview-title">短信预览</div>
        <div class="phone-wrapper">
          <div class="phone-shell">
            <div class="phone-speaker"></div>
            <div class="phone-screen">
              <div class="phone-status-bar">
                <span>9:41</span>
                <span class="phone-status-icons">▲ ◈ ▮</span>
              </div>
              <div class="sms-app-header">
                <span class="sms-sender">10690</span>
                <span class="sms-carrier">短信</span>
              </div>
              <div class="sms-bubble-area">
                <div class="sms-time-label">今天 09:41</div>
                <div class="sms-bubble" v-if="previewItem">
                  {{ renderedPreview }}
                </div>
                <div class="sms-bubble sms-bubble--empty" v-else>点击左侧模板预览效果</div>
              </div>
            </div>
            <div class="phone-home"></div>
          </div>
        </div>

        <!-- 参数示例编辑器 -->
        <div class="preview-params" v-if="previewItem && previewParams.length">
          <p class="preview-params__title">参数示例值（用于预览替换）</p>
          <div v-for="param in previewParams" :key="param.key" class="preview-param-row">
            <span class="preview-param-key">#{{ param.key }}#</span>
            <el-input v-model="param.value" size="mini" style="flex:1" :placeholder="param.key"></el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增模板对话框 -->
    <el-dialog title="新增自定义模板" :visible.sync="addDialogVisible" width="520px" :close-on-click-modal="false">
      <el-form :model="newTemplate" :rules="newTemplateRules" ref="newTemplateForm" label-width="120px">
        <el-form-item label="模板标识" prop="identification">
          <el-input v-model="newTemplate.identification" placeholder="英文大写，如 CUSTOM_NOTICE" maxlength="64"></el-input>
          <p class="util-remark">唯一标识，用于系统匹配发送场景</p>
        </el-form-item>
        <el-form-item label="模板名称" prop="label">
          <el-input v-model="newTemplate.label" placeholder="如：活动通知" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="默认文案" prop="defaultContent">
          <el-input type="textarea" :rows="3" v-model="newTemplate.defaultContent"
            placeholder="默认短信内容，用 #参数名# 表示参数" maxlength="180"
            ref="newTplInput"
            @focus="focusItem = '__new__'"></el-input>
          <div class="param-tags" style="margin-top:6px">
            <span class="param-tags__title">常用参数：</span>
            <el-tag
              v-for="(label, key) in PARAM_LABELS" :key="key"
              size="mini" type="primary" class="param-tag"
              @click="insertParamNew(key)">
              {{ label }}
              <span class="param-tag__code">#{{ key }}#</span>
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="参数说明">
          <el-input v-model="newTemplate.remark" placeholder="如：必填参数：#code#" maxlength="100"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAdd">确认新增</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "smsTemplate",
  data() {
    const newTemplateRules = {
      identification: [
        { required: true, message: '请输入模板标识', trigger: 'blur' },
        { pattern: /^[A-Z0-9_]+$/, message: '只允许英文大写字母、数字和下划线', trigger: 'blur' },
      ],
      label: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
      defaultContent: [{ required: true, message: '请输入默认文案', trigger: 'blur' }],
    };
    return {
      activeName: "driverSms",
      driverSms: [],
      passengerSms: [],
      loading: false,
      previewItem: null,
      previewParams: [],
      focusItem: null,
      addDialogVisible: false,
      addDialogBusiness: '',
      addDialogTarget: '',
      newTemplate: { identification: '', label: '', defaultContent: '', remark: '', platformType: null, business: '', sort: 100 },
      newTemplateRules,
      PARAM_LABELS: {
        code:           '验证码',
        line:           '线路',
        scheduling:     '班次',
        number:         '人数',
        name:           '姓名',
        customerPhone:  '乘客电话',
        driverPhone:    '司机电话',
        license:        '车辆号牌',
        date:           '出发日期',
        location:       '出发地点',
        money:          '金额',
        time:           '到账时间',
        orderTime:      '出发时间',
        startPointName: '上车地点',
        disableDays:    '封禁天数',
        servicePhone:   '客服电话',
      },
    };
  },
  computed: {
    dingzhiPassenger() {
      return this.passengerSms.filter(item => item.business === 'dingzhi')
    },
    wenlvPassenger() {
      return this.passengerSms.filter(item => item.business === 'wenlv')
    },
    renderedPreview() {
      if (!this.previewItem) return '';
      const tpl = this.previewItem.template || this.previewItem.defaultContent || '';
      let result = tpl;
      this.previewParams.forEach(p => {
        if (p.value) {
          result = result.replace(new RegExp('#' + p.key + '#', 'g'), p.value);
        }
      });
      return result;
    },
  },
  methods: {
    /**
     * 使用默认文案
     */
    defaultClick(item) {
      item.template = item.defaultContent || '';
    },
    /**
     * 批量保存（当前 tab 的所有模板的 template/isSend 状态）
     */
    async saveClick(type) {
      this.loading = true;
      const list = type === 'passengerSms'
        ? [...this.dingzhiPassenger, ...this.wenlvPassenger]
        : this.driverSms;
      const url = "/api/v1/manage/sms/templates";
      const template = JSON.stringify(list);
      const data = await this.$axios.post(url, { template });
      if (data && data.code == 1) {
        this.$message.success("保存成功！");
        this.getTemplate();
      }
      this.loading = false;
    },
    setPreview(item) {
      this.previewItem = item;
      const tpl = item.template || item.defaultContent || '';
      const matches = tpl.match(/#([^#]+)#/g) || [];
      const keys = [...new Set(matches.map(m => m.replace(/#/g, '')))];
      this.previewParams = keys.map(key => ({ key, value: '' }));
    },
    itemParams(item) {
      const tpl = item.remark || item.defaultContent || '';
      const matches = tpl.match(/#([^#]+)#/g) || [];
      return [...new Set(matches.map(m => m.replace(/#/g, '')))];
    },
    insertParam(item, param) {
      const refKey = 'tpl_' + item.identification;
      const inputComp = this.$refs[refKey];
      const el = inputComp
        ? (Array.isArray(inputComp) ? inputComp[0] : inputComp).$el.querySelector('textarea')
        : null;
      const insert = '#' + param + '#';
      if (el) {
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const val = item.template || '';
        item.template = val.slice(0, start) + insert + val.slice(end);
        this.$nextTick(() => {
          el.focus();
          const pos = start + insert.length;
          el.setSelectionRange(pos, pos);
        });
      } else {
        item.template = (item.template || '') + insert;
      }
      if (item === this.previewItem) {
        const tpl = item.template || item.defaultContent || '';
        const ms = tpl.match(/#([^#]+)#/g) || [];
        const keys = [...new Set(ms.map(m => m.replace(/#/g, '')))];
        this.previewParams = keys.map(k => this.previewParams.find(p => p.key === k) || { key: k, value: '' });
      }
    },
    insertParamNew(param) {
      const inputComp = this.$refs.newTplInput;
      const el = inputComp ? inputComp.$el.querySelector('textarea') : null;
      const insert = '#' + param + '#';
      if (el) {
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const val = this.newTemplate.defaultContent || '';
        this.newTemplate.defaultContent = val.slice(0, start) + insert + val.slice(end);
        this.$nextTick(() => {
          el.focus();
          const pos = start + insert.length;
          el.setSelectionRange(pos, pos);
        });
      } else {
        this.newTemplate.defaultContent = (this.newTemplate.defaultContent || '') + insert;
      }
    },
    addItem(target, business) {
      this.addDialogTarget = target;
      this.addDialogBusiness = business || '';
      this.newTemplate = {
        identification: '', label: '', defaultContent: '', remark: '',
        platformType: null, business: business || '', sort: 100
      };
      this.addDialogVisible = true;
      this.$nextTick(() => { this.$refs.newTemplateForm && this.$refs.newTemplateForm.clearValidate(); });
    },
    async confirmAdd() {
      this.$refs.newTemplateForm.validate(async valid => {
        if (!valid) return;
        const url = '/api/v1/manage/sms/templates/single';
        const params = {
          identification: this.newTemplate.identification,
          label: this.newTemplate.label,
          defaultContent: this.newTemplate.defaultContent,
          remark: this.newTemplate.remark || '',
          template: '',
          isSend: true,
          platformType: this.newTemplate.platformType,
          business: this.addDialogBusiness || this.newTemplate.business || '',
          sort: this.newTemplate.sort || 100,
        };
        const data = await this.$axios.post(url, params);
        if (data && data.code == 1) {
          this.addDialogVisible = false;
          this.$message.success('模板新增成功');
          this.getTemplate();
        }
      });
    },
    removeItem(target, index) {
      const item = this[target][index];
      if (item && item.isSystem === 1) {
        this.$message.warning('系统内置模板不可删除');
        return;
      }
      this.$confirm('确定删除此自定义模板？', '提示').then(async () => {
        if (item && item.id) {
          const { code } = await this.$axios.delete('/api/v1/manage/sms/templates/' + item.id);
          if (code == 1) {
            if (this.previewItem === item) this.previewItem = null;
            this.getTemplate();
          }
        } else {
          this[target].splice(index, 1);
          if (this.previewItem === item) this.previewItem = null;
        }
      }).catch(() => {});
    },
    removeItemByRef(item) {
      if (item && item.isSystem === 1) {
        this.$message.warning('系统内置模板不可删除');
        return;
      }
      this.$confirm('确定删除此自定义模板？', '提示').then(async () => {
        if (item && item.id) {
          const { code } = await this.$axios.delete('/api/v1/manage/sms/templates/' + item.id);
          if (code == 1) {
            if (this.previewItem === item) this.previewItem = null;
            this.getTemplate();
          }
        } else {
          const idx = this.passengerSms.indexOf(item);
          if (idx > -1) this.passengerSms.splice(idx, 1);
          if (this.previewItem === item) this.previewItem = null;
        }
      }).catch(() => {});
    },
    /**
     * 获取-短信模板（接口驱动，包含租户自定义+平台默认合并）
     */
    async getTemplate() {
      const url = "/api/v1/manage/sms/templates";
      const { code, data } = await this.$axios.get(url);
      if (code == 1 && data && data.length > 0) {
        const pt = this.mixinUserInfo.platformType;
        // 弹性分组：按 platformType 和 business 路由
        // 司机端： platformType 与当前平台类型匹配, 或 platformType=NULL
        // 小程序： business 为 dingzhi / wenlv / changzhan
        const driverItems = data.filter(item => {
          if (pt === 1 || pt === 2) {
            return item.platformType === 1 && !item.business;
          } else if (pt === 3) {
            return item.platformType === 3;
          } else if (pt === 4) {
            return item.platformType === 4 && !item.business;
          }
          return !item.business;
        });
        // 注入通用验证码模板（无 platformType 的）
        const commonItems = data.filter(item => !item.platformType);
        this.driverSms = [...commonItems, ...driverItems];

        if (pt !== 3) {
          const passengerItems = data.filter(item => {
            if (pt === 1 || pt === 2) {
              return item.business === 'dingzhi' || item.business === 'wenlv';
            } else if (pt === 4) {
              return item.business === 'changzhan';
            }
            return item.business === 'dingzhi' || item.business === 'wenlv';
          });
          this.passengerSms = passengerItems;
        }
      }
    },
  },
  created() {
    this.getTemplate();
  },
};
</script>

<style lang="less">
#smsTemplate {
  .sms-layout {
    display: flex;
    gap: 24px;
    align-items: flex-start;
  }

  .sms-editor {
    flex: 1;
    min-width: 0;
  }

  .sms-preview {
    width: 300px;
    flex-shrink: 0;
    position: sticky;
    top: 20px;
  }

  .preview-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
    text-align: center;
  }

  .phone-wrapper {
    display: flex;
    justify-content: center;
  }

  .phone-shell {
    width: 220px;
    background: #1a1a1a;
    border-radius: 32px;
    padding: 14px 10px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.3), inset 0 0 0 2px #333;
    position: relative;
  }

  .phone-speaker {
    width: 50px;
    height: 6px;
    background: #333;
    border-radius: 3px;
    margin: 0 auto 10px;
  }

  .phone-screen {
    background: #f5f5f5;
    border-radius: 18px;
    overflow: hidden;
    min-height: 320px;
  }

  .phone-status-bar {
    background: #fff;
    padding: 6px 12px;
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    color: #333;
    font-weight: 600;
  }

  .phone-status-icons {
    letter-spacing: 2px;
    font-size: 9px;
  }

  .sms-app-header {
    background: #f5f5f5;
    padding: 8px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
  }

  .sms-sender {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .sms-carrier {
    font-size: 10px;
    color: #999;
    margin-top: 1px;
  }

  .sms-bubble-area {
    padding: 12px 10px;
    min-height: 200px;
  }

  .sms-time-label {
    text-align: center;
    font-size: 10px;
    color: #999;
    margin-bottom: 10px;
  }

  .sms-bubble {
    background: #e5e5ea;
    border-radius: 14px 14px 14px 2px;
    padding: 8px 12px;
    font-size: 12px;
    color: #1a1a1a;
    line-height: 1.6;
    word-break: break-all;
    max-width: 90%;
  }

  .sms-bubble--empty {
    color: #bbb;
    font-style: italic;
    background: #ebebeb;
  }

  .phone-home {
    width: 40px;
    height: 5px;
    background: #444;
    border-radius: 3px;
    margin: 10px auto 0;
  }

  .preview-params {
    margin-top: 16px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
  }

  .preview-params__title {
    font-size: 12px;
    color: #606266;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .preview-param-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  .preview-param-key {
    font-size: 11px;
    color: #409EFF;
    white-space: nowrap;
    min-width: 60px;
    font-family: monospace;
  }

  .sms-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .smsItem {
    border: 1.5px solid #e4e7ed;
    border-radius: 8px;
    padding: 12px 14px;
    cursor: pointer;
    transition: border-color 0.2s, box-shadow 0.2s;
    background: #fff;

    &:hover {
      border-color: #409EFF;
    }

    &--active {
      border-color: #409EFF;
      box-shadow: 0 0 0 2px rgba(64,158,255,0.15);
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
    }

    &__label {
      font-size: 13px;
      font-weight: 600;
      color: #303133;
    }

    &__actions {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
  }

  .sms-group-title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 10px;
    padding-left: 4px;
    border-left: 3px solid #409EFF;
    padding-left: 8px;
  }

  .sms-footer {
    display: flex;
    gap: 10px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
    align-items: center;
  }

  .param-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding: 8px 10px;
    background: #f4f7fe;
    border-radius: 6px;
    border: 1px dashed #c0d4f5;
  }

  .param-tags__title {
    font-size: 11px;
    color: #909399;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .param-tag {
    cursor: pointer;
    user-select: none;
    transition: all 0.15s;
    display: inline-flex;
    align-items: center;
    gap: 3px;

    &:hover {
      background: #409EFF;
      color: #fff;
      border-color: #409EFF;

      .param-tag__code {
        color: rgba(255,255,255,0.8);
      }
    }
  }

  .param-tag__code {
    font-family: monospace;
    font-size: 10px;
    color: #909399;
    transition: color 0.15s;
  }

  .custom-el-tabs {
    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }
}
</style>
